import { z } from 'zod'

export const Handles = z.object({
  owner_c: z.number().int().nullable(),
  admin_c: z.number().int().nullable()
})

export type Handles = z.infer<typeof Handles>
